import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import { Route, Routes, useLocation, useNavigate, } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
// import GlobalStyles from 'components/GlobalStyles';
import { useStore, } from '@mcn-platform/models';
import { portalTheme } from '@mcn-platform/converse-lib';
import Error from './Error';
import RenderPage, { buildPageDefinition, getPageConfigId, initPageContext, initPageData, } from './RenderPage';
import initRegistry from './RegistryInit';
import navigationActions from '../portal/common/navigationActions';
import PortalGlobalStyles from '../portal/common/PortalGlobalStyles';
import MoveToTop from '../portal/common/MoveToTop';
import GlobalConfirmDialog from '../portal/globalDialog/GlobalConfirmDialog';
initRegistry();
const DynamicPortal = ({ rootPath, portal, pageType, objectId, modifiers, querystring, requestContext, doPreload, }) => {
    // this requires portal definition to be loaded already
    const navigate = useNavigate();
    const location = useLocation();
    const store = useStore();
    // these are pulled in because it forces a refresh when either value changess,
    // like when a user logs in or their access groups change.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { isAnonymous, currentAccess } = store;
    if (!portal) {
        return _jsx(Error, { message: "Portal required in DynamicPortal" });
    }
    // console.log('context stuff', { isAnonymous, currentAccess });
    // if we have page config with that ID use it, otherwise use default based
    // on pageType.
    const configId = getPageConfigId(portal, pageType, objectId, requestContext);
    const data = initPageData(portal, pageType, objectId, modifiers, querystring);
    const nav = navigationActions(navigate, location, rootPath);
    data.landingPageAction = (selectedItem) => {
        nav.landingPage(selectedItem);
    };
    data.deliveryPageAction = (selectedItem) => {
        nav.deliveryPage(selectedItem);
    };
    data.categoryPageAction = (categoryId) => {
        nav.categoryPage(categoryId);
    };
    data.membershipCheckoutAction = (membershipID) => {
        nav.membershipCheckout(membershipID);
    };
    data.searchAction = (str) => {
        navigate(`${rootPath}/search?q=${str}`);
    };
    data.instructorAction = (instructorID) => {
        nav.instructorAction(instructorID);
    };
    if (data.courseID) {
        data.course = store.getOrLoad('course', data.courseID);
    }
    if (data.programID) {
        data.program = store.getOrLoad('program', data.programID);
    }
    const context = initPageContext(portal);
    const pageDefinition = buildPageDefinition(configId, context);
    // console.log('Root Path: ', {
    //   rootPath,
    //   hub: store.currentHub,
    // });
    return (_jsx(Routes, { children: _jsx(Route, { path: "*", element: (
            // <PortalContext.Provider value={{ baseUrl: rootPath }}>
            _jsxs(ThemeProvider, { theme: portalTheme(portal?.stylesheet), children: [_jsx(PortalGlobalStyles, {}), _jsx(MoveToTop, {}), _jsx(RenderPage, { pageDefinition: pageDefinition, data: data, context: context, 
                        // Only want to do the preload on the client
                        // If the render was done on the server already
                        // dont want to block the viewing of the rendered page
                        doPreload: doPreload }), _jsx(GlobalConfirmDialog, {})] })) }) }));
};
DynamicPortal.defaultProps = {
    querystring: undefined,
};
export default observer(DynamicPortal);
//# sourceMappingURL=DynamicPortal.js.map